import { render, staticRenderFns } from "./AppUpgradeRequired.vue?vue&type=template&id=2b6ec7c8&scoped=true&"
import script from "./AppUpgradeRequired.vue?vue&type=script&lang=js&"
export * from "./AppUpgradeRequired.vue?vue&type=script&lang=js&"
import style0 from "./AppUpgradeRequired.vue?vue&type=style&index=0&id=2b6ec7c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6ec7c8",
  null
  
)

export default component.exports